module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "filterColumns": ""
    }
  }, [_c('center', [(_vm.loaded == false) ? _c('img', {
    staticClass: "imgLoader",
    staticStyle: {
      "padding-top": "3% !important"
    },
    attrs: {
      "src": require("../../shared/assets/images/3dloader.gif")
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.loaded == true) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.columnsLoading == true),
      expression: "columnsLoading== true"
    }]
  }, [_vm._v("Recalculating Columns"), _c('br'), _c('small', [_vm._v("Please wait...")])]), _vm._v(" "), _c('v-data-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.columnsLoading == false),
      expression: "columnsLoading== false"
    }],
    ref: "sortableTable",
    staticClass: "elevation-1 columnTable",
    attrs: {
      "items": _vm.row,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return _vm._l((_vm.liteColumns), function(s, index) {
          return (_vm.fncCheckColumn(s)) ? _c('tr', {
            staticClass: "sortableRow",
            attrs: {
              "id": "rows"
            }
          }, [_c('td', {
            staticClass: "px-1",
            attrs: {
              "width": "5%"
            }
          }, [_c('v-btn', {
            staticClass: "sortHandle",
            staticStyle: {
              "cursor": "move"
            },
            attrs: {
              "icon": ""
            }
          }, [_c('v-icon', [_vm._v("drag_handle")])], 1)], 1), _vm._v(" "), _c('td', {
            attrs: {
              "width": "15%"
            }
          }, [_c('v-switch', {
            on: {
              "change": _vm.fncReorderQuoteColumnsNoSort
            },
            model: {
              value: (s.checked),
              callback: function($$v) {
                _vm.$set(s, "checked", $$v)
              },
              expression: "s.checked"
            }
          })], 1), _vm._v(" "), (!_vm.fncCheckNumber(s.id)) ? _c('td', {
            attrs: {
              "width": "40%"
            },
            domProps: {
              "innerHTML": _vm._s(_vm.fncGetLabel(s.label))
            }
          }) : _vm._e(), _vm._v(" "), (_vm.fncCheckNumber(s.id)) ? _c('td', {
            attrs: {
              "width": "80%"
            }
          }, [_c('v-select', {
            staticStyle: {
              "width": "87%",
              "display": "block",
              "float": "left",
              "margin-top": "0px !important"
            },
            attrs: {
              "label": "Select Column Role",
              "item-value": "id",
              "items": _vm.repRoles,
              "item-text": "name",
              "solo": "",
              "outline": "",
              "autocomplete": ""
            },
            on: {
              "input": function($event) {
                return _vm.fncSetId(s)
              }
            },
            model: {
              value: (s.id),
              callback: function($$v) {
                _vm.$set(s, "id", $$v)
              },
              expression: "s.id"
            }
          })], 1) : _vm._e()]) : _vm._e()
        })
      }
    }], null, false, 913502816)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pl-4 pr-1 pb-4 buttonHolder"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('v-btn', {
    staticClass: "text-xs-right cancelButton",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncHideModal.apply(null, arguments)
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-btn', {
    staticClass: "text-xs-right",
    attrs: {
      "color": "success"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.fncSaveSettings()
      }
    }
  }, [_vm._v("Update")])], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}